module.exports = __webpack_public_path__ + "static/bigcommerce_2-ea5d98554d00ba8f50eeb52e2809256e.png";